import { createContext, useContext } from 'react';
const context = createContext(null);
export const LoadableProvider = context.Provider;
export const useRegisterComponent = (moduleId, ssr) => {
    const collector = useContext(context);
    if (!collector) {
        if (ssr) {
            throw new Error('`loadable` must be used inside a `LoadableProvider` when using SSR or SSG. Check the render or server entry and make sure it is wrapped in a `LoadableProvider`.');
        }
        return;
    }
    collector.register(moduleId);
};
